import React, { createContext, useState, useContext, useCallback } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';

import { DB } from '~/services/firebase';
import IBanner from '~/interfaces/IBanner';

interface BannersContextData {
  banners: IBanner[];
  loadBanners(id: string): Promise<void>;
  clearContext(): void;
  isInitialized: boolean;
}

const BannersContext = createContext<BannersContextData>(
  {} as BannersContextData,
);

export const BannersProvider: React.FC = ({ children }) => {
  const [banners, setBanners] = useState<IBanner[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);

  const clearContext = useCallback(() => {
    setBanners([]);
  }, []);

  const loadBanners = useCallback(async (id: string) => {
    const q = query(collection(DB, 'banners'), where('company_id', '==', id));
    const querySnapshot = await getDocs(q);

    const items: IBanner[] = [];

    querySnapshot.docs.forEach(item => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as IBanner;

      items.push(parseItem);
    });

    setBanners(items);
    setIsInitialized(true);
  }, []);

  return (
    <BannersContext.Provider
      value={{ banners, loadBanners, clearContext, isInitialized }}
    >
      {children}
    </BannersContext.Provider>
  );
};

export function useBanners(): BannersContextData {
  const context = useContext(BannersContext);
  return context;
}
